const badgePalette = (tokens) => {
    return {
        font: {
            family: tokens.badgeFontFamily,
            weight: tokens.badgeFontWeight
        },
        size: {
            medium: {
                border: {
                    radius: tokens.badgeSizeMediumRadiusRound,
                    width: tokens.badgeSizeMediumBorderWidth
                },
                height: tokens.badgeSizeMediumMinHeight,
                paddingLeft: tokens.badgeSizeMediumPaddingLeft,
                paddingRight: tokens.badgeSizeMediumPaddingRight,
                font: {
                    size: tokens.badgeMFontSize,
                    lineHeight: tokens.badgeMLineHeight
                }
            },
            small: {
                border: {
                    radius: tokens.badgeSizeSmallRadiusRound
                    // TODO: Follow up with Ann; is border width missing?
                    // width: tokens.badgeSizeSmallBorderWidth,
                },
                height: tokens.badgeSizeSmallMinHeight,
                paddingLeft: tokens.badgeSizeSmallPaddingLeft,
                paddingRight: tokens.badgeSizeSmallPaddingRight,
                font: {
                    size: tokens.badgeSFontSize,
                    lineHeight: tokens.badgeSLineHeight
                }
            },
            input: {
                height: tokens.badgeSizeInputMinHeight,
                font: {
                    size: tokens.badgeInputFontSize,
                    lineHeight: tokens.badgeInputLineHeight
                }
            }
        },
        interactive: {
            neutral: {
                text: tokens.badgeColorTextInteractiveNeutral,
                background: {
                    default: tokens.badgeColorBgInteractiveNeutralDefault,
                    hover: tokens.badgeColorBgInteractiveNeutralHover,
                    focus: tokens.badgeColorBgInteractiveNeutralFocus,
                    disabled: tokens.badgeColorBgInteractiveNeutralDisabled,
                    selected: {
                        default: tokens.badgeColorBgInteractiveNeutralSelectedDefault,
                        hover: tokens.badgeColorBgInteractiveNeutralSelectedHover
                    }
                },
                border: {
                    default: tokens.badgeColorBorderInteractiveNeutralDefault,
                    hover: tokens.badgeColorBorderInteractiveNeutralHover,
                    focus: tokens.badgeColorBorderInteractiveNeutralFocus,
                    disabled: tokens.badgeColorBorderInteractiveNeutralDisabled,
                    selected: {
                        default: tokens.badgeColorBorderInteractiveNeutralSelectedDefault,
                        hover: tokens.badgeColorBorderInteractiveNeutralSelectedHover
                    }
                }
            },
            subtle: {
                text: tokens.badgeColorTextInteractiveSubtle,
                background: {
                    default: tokens.badgeColorBgInteractiveSubtleDefault,
                    hover: tokens.badgeColorBgInteractiveSubtleHover,
                    focus: tokens.badgeColorBgInteractiveSubtleFocus,
                    disabled: tokens.badgeColorBgInteractiveSubtleDisabled,
                    selected: {
                        default: tokens.badgeColorBgInteractiveSubtleSelectedDefault,
                        hover: tokens.badgeColorBgInteractiveSubtleSelectedHover
                    }
                },
                border: {
                    default: tokens.badgeColorBorderInteractiveSubtleDefault,
                    hover: tokens.badgeColorBorderInteractiveSubtleHover,
                    focus: tokens.badgeColorBorderInteractiveSubtleFocus,
                    disabled: tokens.badgeColorBorderInteractiveSubtleDisabled,
                    selected: {
                        default: tokens.badgeColorBorderInteractiveSubtleSelectedDefault,
                        hover: tokens.badgeColorBorderInteractiveSubtleSelectedHover
                    }
                }
            },
            emphasis: {
                text: tokens.badgeColorTextInteractiveEmphasis,
                background: {
                    default: tokens.badgeColorBgInteractiveEmphasisDefault,
                    hover: tokens.badgeColorBgInteractiveEmphasisHover,
                    focus: tokens.badgeColorBgInteractiveEmphasisFocus,
                    disabled: tokens.badgeColorBgInteractiveEmphasisDisabled,
                    selected: {
                        default: tokens.badgeColorBgInteractiveEmphasisSelectedDefault,
                        hover: tokens.badgeColorBgInteractiveEmphasisSelectedHover
                    }
                },
                border: {
                    default: tokens.badgeColorBorderInteractiveEmphasisDefault,
                    hover: tokens.badgeColorBorderInteractiveEmphasisHover,
                    focus: tokens.badgeColorBorderInteractiveEmphasisFocus,
                    disabled: tokens.badgeColorBorderInteractiveEmphasisDisabled,
                    selected: {
                        default: tokens.badgeColorBorderInteractiveEmphasisSelectedDefault,
                        hover: tokens.badgeColorBorderInteractiveEmphasisSelectedHover
                    }
                }
            }
        },
        error: {
            subtle: {
                text: tokens.badgeColorTextErrorSubtle,
                background: tokens.badgeColorBgErrorSubtle,
                border: tokens.badgeColorBorderErrorSubtle
            }
        },
        static: {
            subtle: {
                text: tokens.badgeColorTextStaticSubtle,
                background: tokens.badgeColorBgStaticSubtle,
                border: tokens.badgeColorBorderStaticSubtle
            },
            emphasis: {
                text: tokens.badgeColorTextStaticEmphasis,
                background: tokens.badgeColorBgStaticEmphasis,
                border: tokens.badgeColorBorderStaticEmphasis
            },
            neutral: {
                background: tokens.badgeColorBgStaticNeutral,
                border: tokens.badgeColorBorderStaticNeutral
            }
        }
    };
};
export default badgePalette;
//# sourceMappingURL=badge.js.map